import { ThemeProvider } from '@mui/material/styles';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectWdCurrentLayoutConfig, selectNavbarTheme } from 'app/store/core/settingsSlice';
import { selectWdNavbar } from 'app/store/core/navbarSlice';
import NavbarStyle1 from './navbar/style-1/NavbarStyle1';
// import NavbarStyle1 from './navbar/style-1/NavbarStyle1';
// import NavbarStyle3 from './navbar/style-3/NavbarStyle3';

function NavbarWrapperLayout1({ children }) {
  const config = useSelector(selectWdCurrentLayoutConfig);
  const navbar = useSelector(selectWdNavbar);

  const navbarTheme = useSelector(selectNavbarTheme);

  return (
    <>
      <ThemeProvider theme={navbarTheme}>
        {config.navbar.style === 'style-1' && <NavbarStyle1 config={config} navBarState={navbar} />}
      </ThemeProvider>
      {children}
    </>
  );
}

export default memo(NavbarWrapperLayout1);
